import React from 'react'
import Layout from '../components/layout/Layout'
import SupabaseDebugger from '../components/debug/SupabaseDebugger'
import SafeIcon from '../common/SafeIcon'
import * as FiIcons from 'react-icons/fi'

const { FiTool } = FiIcons

const DebugPage = () => {
  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100 flex items-center gap-2">
            <SafeIcon icon={FiTool} className="text-primary-500" />
            Debug Tools
          </h1>
          <p className="text-gray-600 dark:text-gray-400 mt-1">
            Diagnose and troubleshoot database connectivity issues
          </p>
        </div>

        <SupabaseDebugger />
      </div>
    </Layout>
  )
}

export default DebugPage